<template>
	<div>
		<div v-if="!showDocsPage" class="height-100dvh">
			<NcdTopContainer />
			<template v-if="shimmerLoader">
				<div class="mobile-body-uld">
					<div class="w-75 mt-2">
						<b-skeleton height="25px"> </b-skeleton>
					</div>
					<div class="d-flex flex-wrap justify-content-between">
						<div
							class="doctype-card-shimmer d-flex justify-content-center align-items-center mt-2"
							v-for="i in shimmerLoop"
							:key="i"
						>
							<b-skeleton class="h-100 w-100"> </b-skeleton>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="mobile-body-uld">
					<!-- <div class="mobhead-uld" >Upload Documents</div> -->
					<div class="d-flex justify-content-between flex-wrap ml-1">
						<div
							class="doctype-card d-flex justify-content-center align-items-center mt-2"
							v-for="(docs, index) in documents"
							:key="index + 'docs'"
						>
							<div class="w-50" @click="navigateToDocument(docs, index)">
								<div class="ml-2 d-flex justify-content-center">
									<img :src="docs.image" />
								</div>
								<div class="mr-2 doccard-titles mt-2">
									{{ docs.categoryTitle }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>
		<div v-else>
			<DocCatergories
				@showDocsPage="changeView"
				:allDocs="allDocs"
				@update-doc="updateDoc"
				:selectedIndex="selectedIndex"
				:shimmerLoader="shimmerLoader"
			/>
		</div>
	</div>
</template>

<script>
import pdf from "vue-pdf";
import candidateDocsListMixin from "../../../views/CandidateDocuments/CandidateDocsListMixin.js";
import successModal from "../../../components/mixin/toast";
import errorModal from "../../../components/mixin/toast";
import { required } from "vuelidate/lib/validators";
import NcdTopContainer from "@/components/NewCandidateDashboard/NcdTopContainer.vue";
import DocCatergories from "../../MobileComponents/Documents/DocCatergories.vue";

export default {
	name: "Document",
	mixins: [successModal, errorModal, candidateDocsListMixin],
	components: {
		pdf,
		NcdTopContainer,
		DocCatergories,
	},
	data() {
		return {
			shimmerLoop: 4,
			shimmerLoader: false,
			allDocs: {},
			loading: false,
			LoaderStatus: false,
			showDocsPage: false,
			loopvar: 10,
			preview: false,
			selectedDocID: "",
			docsDetails: {},
			selectedIndex: null,
			showAction: false,
			documents: [],
			document: "",
			documentName: "",
			replaceName: "",
			numPages: 0,
			currentPage: 1,
			perPage: 1,
			pdfLink: {
				link: "",
				name: "",
			},
			fileDetails: {
				file: "",
				fileName: "",
				present: false,
				flag: true,
				size: false,
				sourceKey: 0,
				documentID: "",
			},
		};
	},
	created() {
		this.showDocsPage =
			this.$route.query.showDocsPage === true ||
			this.$route.query.showDocsPage === "true";
		this.selectedIndex = parseInt(this.$route.query.selectedDocID);
		this.shimmerLoader = true;
		this.getAllDocs();
	},
	validations() {
		return {
			document: {
				required,
			},
		};
	},
	watch:{
		$route(){
			this.getAllDocs();
		}
	},
	methods: {
		updateDoc(data) {
			this.navigateToDocument(data.document, data.selectedIndex);
		},
		navigateToDocument(document, index) {
			this.$router.push({
				query: {
					showDocsPage: true,
					selectedDocID: index,
				},
			});
			this.showDocsPage = true;
			this.selectedIndex = index;
			this.allDocs = document;
		},
		changeView(val) {
			this.showDocsPage = val;
		},
	},
};
</script>

<style>
.mobile-doc-body {
	height: 92%;
	padding: 15px;
	background-color: #e9ecef;
	position: relative;
}

.doc-whiteContainer {
	border-radius: 5px;
	background: #fff;

	height: 95%;
	overflow: auto;
}

.doc-particularDoc {
	padding: 15px;

	border: 1px solid #cfd1d3;
}

.doc-name {
	color: #000;
	font-size: 14px;
	font-weight: 600;
}

.doc-small-txt {
	color: #7a7a7a;
	font-size: 10px;
	font-weight: 500;
}

#deleteModal .modal-content {
	width: 95%;
	left: 9px;
}

.doc-uploadResume {
	border-radius: 12px;
	border: 1px dashed var(--gray-200, #e4e7ec);
	background: var(--base-white, #fff);
	padding: 30px 0px;
}

/* FOR B-FORM-FILE */

.doc-uploadResume .custom-file {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
}

.doc-uploadResume .custom-file-input {
	height: 100%;
}

.doc-uploadResume .custom-file-label {
	height: 100%;
	color: transparent !important;
	border: 1px solid transparent !important;
	background-color: transparent !important;
}

.doc-uploadResume .custom-file-label::after {
	background-color: transparent;
}

.doc-uploadResume .custom-file-input ~ .custom-file-label[data-browse]::after {
	content: attr(no-data);
}

.doc-uploadResume .custom-file-input:focus ~ .custom-file-label {
	border-color: transparent !important;
	box-shadow: none !important;
}

.doc-header {
	display: flex;
	align-items: center;
	background: #fff;
	box-shadow: 0px 4px 20px 0px #000;
	height: 8%;
	padding: 15px;
}
.doctype-card {
	gap: 10px;
	width: 48.2%;
	height: 122px;
	background: #ffffff;
	border-radius: 4px;
}

.doctype-card-shimmer {
	gap: 10px;
	width: 48.2%;
	height: 122px;
	border-radius: 4px;
}
.mobhead-uld {
	font-family: "Lato";
	font-weight: 600;
	font-size: 18px;
	color: #000000;
}
.doccard-titles {
	font-family: "Lato";
	font-weight: 500;
	font-size: 12px;
	text-align: center;
	color: #000000;
}
</style>
